import React from 'react';

// TODO: Implement AdminPanelPageSkeleton component
export const AdminPanelPageSkeleton = () => {
  return <div>Loading admin panel...</div>;
};

// export default AdminPanelPageSkeleton;
